export class EtkDmsSettings {
  isEnabled: boolean = false;
  employeeNumber: string = '';
  customerNumber: number;
  cashSalesCustomerNumber: number;
  orderNumber: string = '';
  password: string = '';
  isAutomaticPartsInfoEnabled: boolean = false;
  isPartsInfoInPicturePanelEnabled: boolean = false;
  isUsDirectEnabled: boolean = false;
  usDirectFilename: string = '';
  useDcomForPricesAndAvailabilities: boolean = false;
  vatRateCode1: number;
  vatRateCode2: number;
  vatRateCode3: number;
  vatRateCode4: number;
  vatRateCodeC: number;
  vatRateCodeL: number;
  vatRateReplacementParts: number;
}
